import React, { useState, useEffect } from 'react'
import { moviesApi } from '../../../api'
import CastPerson from './CastPerson'

const CastPeople = (props) => {
    const { match: { params: { id } } } = props
    const parsedId = parseInt(id)
    const [state, setState] = useState({ loading: true, error: null, data: null })

    useEffect(() => {
        const getPerson = async () => {
            try {
                const { data } = await moviesApi.castPeople(parsedId)
                setState(prev => { return { ...prev, data, loading: false } })
            } catch (error) {
                setState(prev => { return { ...prev, error, loading: false } })
            }
        }
        getPerson()
    }, [parsedId])
    const { loading, error, data } = state
    return (
        <CastPerson loading={loading} error={error} result={data} />
    )
}

export default CastPeople

